// CountryStateCity data, ODbL-1.0. Pin the dataset version and load only the
// selected country's states and selected state's cities, not the world dataset.
const baseURL = "https://cdn.jsdelivr.net/npm/@countrystatecity/countries-browser@1.0.4/dist/data";
const cache = new Map();
async function load(path) {
  if (cache.has(path)) return cache.get(path);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch(`${baseURL}/${path}`, { signal: controller.signal });
    if (!response.ok) throw new Error("Location data could not be loaded");
    const items = await response.json();
    if (!Array.isArray(items)) throw new Error("Invalid location data");
    if (cache.size >= 50) cache.delete(cache.keys().next().value);
    cache.set(path, items);
    return items;
  } finally {
    clearTimeout(timeout);
  }
}
export const getCountries = () => load("countries.json");
export const getStatesOfCountry = (country) => load(`states/${encodeURIComponent(country)}.json`);
export const getCitiesOfState = (country, state) => load(`cities/${encodeURIComponent(country)}-${encodeURIComponent(state)}.json`);
